module.exports = __webpack_public_path__ + "img/default.1131eefb.png";